var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-w"},[_c('div',{staticStyle:{"margin-top":"200px"}}),_vm._v(" "),_c('editor',{attrs:{"api-key":_vm.apiKey,"init":_vm.tinyMceInit}}),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"100px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dcc79e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewsEditor/index.vue
// module id = null
// module chunks = 